import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { PresetItem } from 'types/embedded/preset';

import { PresetsShowGridCard } from './PresetsShowGridCard';

export const PresetsShowGrid: React.FC<{ items: PresetItem[] }> = ({ items }) => {
  if (items.length === 0) {
    return <Alert severity="info">Нет добавленных пресетов</Alert>;
  }

  return (
    <Box sx={{ display: 'grid', gap: '24px', gridTemplateColumns: 'repeat(3, 1fr)' }}>
      {items.map((item) => (
        <PresetsShowGridCard item={item} key={item['@id']} />
      ))}
    </Box>
  );
};
